const  upLoadLogo = (old=false, action) => {
    let { type, payload} = action
    switch (type) {
        case "upLoadLogo":
            return payload
        default:
            return old;
    }
}
export default upLoadLogo